import stateConfig from './config'
import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'
import VueLocalStorage from 'vue-localstorage'
import { Validator } from 'vee-validate'

Vue.use(Vuex)
Vue.use(VueLocalStorage)

export default {
  [stateConfig.LOGIN]: function(state) {
    state.loading = true
  },
  [stateConfig.LOGIN_SUCCESS]: function(state) {
    state.isLoggedIn = true
    state.loading = false
  },
  [stateConfig.LOGIN_FAIL]: function(state) {
    state.loading = false
  },
  [stateConfig.LOGOUT]: function(state) {
    state.isLoggedIn = false
    state.loading = false
  },
  [stateConfig.SELECT_BOT]: function(state) {
    state.isSelectedBot = true
  },
  [stateConfig.LOADING]: function(state) {
    state.loading = !state.loading
  },
  [stateConfig.CLEAR_LOADING]: function(state) {
    state.loading = false
  },
  [stateConfig.SIDEBAR]: function(state) {
    state.openSidebar = !state.openSidebar
  },
  [stateConfig.SELECT_NEW_BOT]: function(state, bot) {
    state.selectedBot = bot
  },
  [stateConfig.UPDATE_SETTING]: function(state, setting) {
    state.setting = setting
  },
  [stateConfig.UPDATE_WELCOME_MESSAGE]: function(state, welcomeMessage) {
    state.welcomeMessage = welcomeMessage
  },
  [stateConfig.UPDATE_MODAL_WELCOME]: function(state, value) {
    if (value) {
      state.showModalWelcome = true
      Vue.localStorage.set('showModalWelcome', true)
    } else {
      state.showModalWelcome = undefined
      Vue.localStorage.remove('showModalWelcome')
    }
  },
  [stateConfig.SET_LANG](state, payload) {
    if (state.userid) {
      var data = {
        lang: payload,
        tutoriallist: state.tutoriallist
      }
      api.updateTutoriallist(data, function(error, response) {
        if (error) {
          console.error(error)
        }
      })
    }
    Vue.i18n.set(payload)
    Validator.localize(payload)
  },
  [stateConfig.UPDATE_ALERT](state, payload) {
    if (state.alert) {
      var alertIndex = state.alert.findIndex(function(alert) {
        return alert.name === payload.name
      })
      if (alertIndex > 0) {
        state.alert[alertIndex] = payload
      } else {
        state.alert.push(payload)
      }
    } else {
      state.alert.push(payload)
    }
    Vue.localStorage.set('alerts', JSON.stringify(state.alert))
  },
  [stateConfig.SET_LIVECHAT_USERS](state, payload) {
    state.livechat.userlist[payload.type].users = payload.users
  },
  [stateConfig.SET_KETSHOP_TOKEN](state, payload) {
    if (payload.useketshop !== 'undefined') state.selectedBot.useketshop = payload.useketshop
    if (payload.ketshop_api_key) state.selectedBot.ketshop_api_key = payload.ketshop_api_key
    if (payload.ketshop_api_secret)
      state.selectedBot.ketshop_api_secret = payload.ketshop_api_secret

    Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
  },
  // $store.commit('modalAssign', {open: true, component: () => import('@/Mootest.vue') })
  modalAssign(state, data) {
    let input = JSON.parse(JSON.stringify(data.input))
    Object.assign(state.modal, { ...data, input })
  },
  allSchoolsAssign(state, data) {
    Object.assign(state.allSchools, data)
  },
  [stateConfig.SET_LIVECHAT_USER](state, payload) {
    state.livechat.currentUser = payload
  },
  ['SET_INTENTS'](state, { intents, loadingIntents }) {
    if (intents !== undefined) {
      state.intents = intents.map(function(val) {
        var intent = { ...val }
        intent.isShow = false

        intent.ableToDelete = ![
          '{welcome}',
          '{default}',
          '{default_comment_to_inbox}',
          '{default_live}'
        ].includes(intent.intentname)
        return intent
      })
    } else {
      state.intents = []
    }
    state.loadingIntents = loadingIntents
  },
  ['SET_INTENT'](state, payload) {
    if (payload.id) {
      var index = state.intents.findIndex(el => {
        return el.id == payload.id
      })
      if (index != -1) {
        Vue.set(state.intents, index, payload)
      } else {
        state.intents.push(payload)
      }
    } else {
      state.intents.push(payload)
    }
  },
  ['DELETE_INTENT'](state, id) {
    var index = state.intents.findIndex(el => {
      return el.id == id
    })
    if (index != -1) {
      state.intents.splice(index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js